<template>
  <div >
    <article v-if="notes.length > 0" class="notes message" 
              v-bind:class="[note_type, {'is-warning': is_sales, 'is-danger': is_admin}]">
      <div class="message-header">
        <p>{{note_type}} Notes</p>
        <span @click="toggle_body"
              class="icon minimize">
          <i v-if="show_body" 
              class="material-icons"
              style="font-size:18px"
              >
          minimize
          </i>
          <i v-else 
              class="material-icons"
              style="font-size:18px"
              >
          maximize
          </i>
        </span>
      </div>
      <div v-if="show_body" class='message-body'>
        <div class=note
          v-for="idx in Object.keys(notes)"
          v-bind:key="note_type + idx"
          @mouseover="showByIndex = idx" 
          @mouseout="showByIndex = null">
          <div class="meta">
            <span class="timestamp">{{human_time(notes[idx].time_created)}}</span>
            <span class="separator">&mdash;</span>
            <span class="part_number">{{notes[idx].part_number}}</span>
            <span class="separator">&mdash;</span>
            <span class="author">{{notes[idx].author__name}}</span>
            <span v-if="is_sales" v-show="showByIndex === idx" @click="$emit('archive_sales_note', notes[idx].id)" 
                  class="icon is-small archive" title="Archive"
                  style="vertical-align:bottom; margin-left:1.5em;">
                <i v-if="show_body" 
                    class="material-icons"
                    style="font-size:18px"
                    >
                archive
                </i>
            </span>
          </div>
          <strong class="text">{{notes[idx].note}}</strong>
        </div>
        <section id="archive" v-if="archived_notes.length>0">
          <div>
            ______________________________
          </div>
          <div style="height:1em">  </div>
          <div>
            ARCHIVE 

              <span  @click="toggle_archive" class="icon" style="vertical-align:bottom; margin-left:1em">
                <i v-if="show_archive" class="material-icons" title="hide">
                toggle_on
                </i>
                <i v-else class="material-icons" title="show">
                toggle_off
                </i>
              </span>

              <!-- <span v-else @click="toggle_archive" class="icon">
                
              </span> -->

          </div>
          <div>
            ______________________________
          </div>
          <div v-if="show_archive">
            <div class=note
              v-for="idx in Object.keys(archived_notes)"
              v-bind:key="note_type +'_arxiv'+ idx">
              <div class="meta">
                <span class="timestamp">{{human_time(archived_notes[idx].time_created)}}</span>
                <span class="separator">&mdash;</span>
                <span class="part_number">{{archived_notes[idx].part_number}}</span>
                <span class="separator">&mdash;</span>
                <span class="author">{{archived_notes[idx].author__name}}</span>
              </div>
              <strong class="text">{{archived_notes[idx].note}}</strong>
            </div>
          </div>
        </section>
        <div v-if="add_note_auth">
          <button :id="note_type+'_quote_button'" class="button is-rounded is-small" :class="{'is-warning': is_sales, 'is-danger': is_admin}"
                @click="newNote(note_type)">
            <span class="icon">
              <i class="material-icons md-18">add</i>
            </span>
            <span>Note</span>
          </button>
        </div>
      </div>

      <!-- <article class="message is-warning">
        <div class="message-header">
          <p>Warning</p>
          <button class="delete" aria-label="delete"></button>
        </div>
        <div class="message-body">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. <strong>Pellentesque risus mi</strong>, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum <a>felis venenatis</a> efficitur. Aenean ac <em>eleifend lacus</em>, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem.
        </div>
      </article> -->



    </article>
    <div v-else>
      <div v-if="add_note_auth" class="add_note_sec">
        <button :id="note_type+'_quote_button'" class="button is-rounded is-small" :class="{'is-warning': is_sales, 'is-danger': is_admin}"
              @click="newNote(note_type)">
          <span class="icon">
            <i class="material-icons md-18">add</i>
          </span>
          <span>Note</span>
        </button>
      </div>
    </div>
  </div>

  
</template>

<script>
import moment from 'moment';

export default {
  name: 'NotesComponent',
  props: {
    // Each set of notes must have a unique note type
    note_type: String,
    all_notes: Array,
    add_note_auth: Boolean,
    part_selected: String,
    customer: String,
  },
  data: function(){
    return {
      show_body: true,
      show_archive: false,
      showByIndex: null,
    }
  },
  watch: {
    part_selected: function(){
      // When the part changes, show all notes
      this.show_body = true
    },
  },
  computed: {
    // a computed getter
    is_admin(){
      // `this` points to the vm instance
      return this.note_type == 'admin'
    },
    is_sales(){
      // `this` points to the vm instance
      return this.note_type == 'sales'
    },
    notes(){
      // Get the current notes of interest 
      // matching the selected part number
      let current_notes = []
      let all_notes = this.all_notes
      for (let idx in all_notes){
        let notes = all_notes[idx]
        if ((notes.part == this.part_selected) | (notes.customer == this.customer)){
          for (let n in notes.notes){
            let note = notes.notes[n]
            if(note.usernotearchive_id == null){
              current_notes.push(note)
            }
          }
          // current_notes = current_notes.concat(notes.notes)
        }
      }
      return current_notes
    },
    archived_notes(){
      // Get the current notes of interest 
      // matching the selected part number
      let archived_notes = []
      let all_notes = this.all_notes
      for (let idx in all_notes){
        let notes = all_notes[idx]
        if ((notes.part == this.part_selected) | (notes.customer == this.customer)){
          for (let n in notes.notes){
            let note = notes.notes[n]
            if(note.usernotearchive_id != null){
              archived_notes.push(note)
            }
          }
          // current_notes = current_notes.concat(notes.notes)
        }
      }
      return archived_notes
    },
  },
  methods: {
    do_archive: function(){
      alert('archive')
    },
    toggle_body: function(){
      this.show_body = !this.show_body
    },
    toggle_archive: function(){
      this.show_archive = !this.show_archive
    },
    human_time: function(time_string){
      // // Remove fractions of seconds, then parse
      // let z_split = time_string.split('+')
      // let d_split = z_split[0].split('.')[0]
      // let new_time_string = d_split + '+' + z_split[1]
      let date = moment(time_string).format('YYYY-MM-DD');
      return date
    },
    newNote: function(note_type){
      if(note_type == 'sales'){
        this.$emit('add_user_note')
      }
      if(note_type == 'admin'){
        this.$emit('add_admin_note')
      }
        
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  article{
    
  }
  .user.notes{
    color:magenta;
  }
  .admin.notes{
    color:red;
  }
  .message-header p:first-letter {
    text-transform:capitalize;
  }
  .note{
    padding:0.4em 0px;
  }
  .meta{
    font-size: 0.75em;
  }
  .author{
    text-transform: capitalize;
  }
  .separator{
    margin: 0 0.5em;
  }
  .note .meta .icon:hover{
    cursor: pointer;
  }
  .material-icons.md-18 {
    font-size: 18px; 
  }
  .add_note_sec{
    padding:1em;
  }
  /* #archive .icon{
    text
  } */
  #archive .icon:hover{
    cursor: pointer;
  }
  .icon.minimize:hover{
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.1);
  }
</style>
